<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>中文官网</el-breadcrumb-item>
        <el-breadcrumb-item>职位管理</el-breadcrumb-item>
        <el-breadcrumb-item>联系方式</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            prop="area"
            width="120"
            label="地区">
          </el-table-column>
          <el-table-column
            align="center"
            width="250"
            prop="menu_list"
            label="经纬坐标">
            <template slot-scope="scope">
              X :
              <el-input v-model="scope.row.longitude" @change="handleChange(scope.row)" style="width:80px;"/>
              Y :
              <el-input v-model="scope.row.latitude" @change="handleChange(scope.row)" style="width:80px;"/>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="地址">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.address" @change="handleChange(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="150"
            prop="contact"
            label="联系人">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.contact" @change="handleChange(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="180"
            prop="email"
            label="邮箱">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.email" @change="handleChange(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="180"
            prop="phone"
            label="电话">
            <template slot-scope="scope">
              <el-input type="text" v-model="scope.row.phone" @change="handleChange(scope.row)"/>
            </template>
          </el-table-column>
        </el-table>

      </template>
    </div>
  </div>
</template>

<script>
import {updateContact, getContactList} from '../../api/contact'

export default {
  name: 'index',
  data () {
    return {
      dialogFormVisible: false,
      tableData: [],
      fields: {
        address: '地址',
        contact: '联系人',
        email: '邮箱',
        phone: '联系电话',
        longitude: '经度',
        latitude: '纬度'
      }
    }
  },
  methods: {
    handleChange (item) {
      let keys = Object.keys(this.fields)
      // 验证表单中的数据是否存在空值,存在空值的话给出提示
      for (let key of keys) {
        if (!item[key]) {
          return this.$notify({
            message: this.fields[key] + '不能为空',
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      }
      updateContact(item).then(response => {
        let {status, message} = response
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    }
  },
  mounted () {
    getContactList().then(response => {
      this.tableData = response.data.table_list
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/contact/index.vue